
<template lang="html">
    <div v-if="meetingStatus !== 'done' && widget">
        <div class="sidebar__widget-area">
            <div class="sidebar__widget-title">Urmatoarea programare:</div>

            <div v-if="meetingStatus === 'processing' && widget.specialist" class="appointment-widget appointment-widget--processing">
                <div
                    class="appointment-widget__specialist-img">
                    <img v-if="user.role=='client'" :src="widget.specialist.image_url" :alt="widget.specialist.full_name"/>
                    <img v-else src="@/assets/images/person-icon.png" alt="User image"/>
                </div>
                <div class="appointment-widget__text">
                    <i class="fas fa-sync fa-spin"></i>
                </div>
            </div>

            <div v-else-if="meetingStatus === 'pending' && widget.specialist" class="appointment-widget appointment-widget--pending">
                <div 
                    class="appointment-widget__specialist-img">
                    <img v-if="user.role=='client'" :src="widget.specialist.image_url" :alt="widget.specialist.full_name"/>
                    <img v-else src="@/assets/images/person-icon.png" alt="User image"/>
                </div>
                <div class="appointment-widget__text">
                    <i class="far fa-clock"></i> 
                    <span> {{timeText}} </span> <span @click="specialistProfile()">{{widget.specialist.full_name}}</span>
                </div>
            </div>

            <div v-else-if="meetingStatus === 'ready' && widget.specialist" class="appointment-widget appointment-widget--ready" style="cursor: pointer;">
                <div
                    class="appointment-widget__specialist-img">
                    <img v-if="user.role=='client'" :src="widget.specialist.image_url" :alt="widget.specialist.full_name"/>
                    <img v-else src="@/assets/images/user.svg" alt="User image"/>
                </div>
                <div @click="$emit('openJoinMeeting')" class="appointment-widget__text">
                    <i class="far fa-clock"></i> 
                    Intră în ședință
                </div>
            </div>
        </div>
        <div class="appointment-widget__subtext" ref="wsub">
            <small>Sau intră direct cu VIDEO apăsând click <span @click="join()">AICI</span></small>
        </div>
        <audio style="display: none;" preload="none" id="appointment-starting-audio">
            <source src="@/assets/audio/appointmentstarting.mp3" type="audio/mpeg">
        </audio>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from '@/config.js';
import * as moment from 'moment';

export default {
    data() {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            timeText: '',
            pendingInterval: null,
            processingInterval: null
        };
    },
    mounted() {
        this.pendingInterval = setInterval(() => {
            this.resolveMeetingStatus();
        }, 1000);
    },
    computed: {
        ...mapGetters({
            widget: 'layout/widget',
            meeting: 'meeting/meeting',
            meetingStatus: 'meeting/status',
            user: 'user/user'
        })
    },
    watch: {
        // "$store._modules.root.state.layout.widget"() {
        //     this.pendingInterval = setInterval(() => {
        //         this.resolveMeetingStatus();
        //     }, 5000);
        // }
    },
    methods: {
        ...mapActions({
            fetchMeeting: 'meeting/meeting',
            fetchAppointmentWidget: 'layout/widget'
        }),
        specialistProfile(){
            this.$router.push('/specialists/profile/'+ this.widget.appointment.specialist_id);
        },
        resolveImage(src) {
            return config.HOST + src;
        },
        setTimerText(date) {
            const start = moment(date.getTime());
            this.timeText = moment.duration(moment().diff(start)).humanize();
        },
        resolveMeetingStatus() {
            var appointment = this.widget.appointment;
            if(appointment) {
                // Set appointment start datetime
                var startDateTime = new Date(appointment.start_timestamp);
                // Set appointment end datetime
                var endDateTime = new Date(appointment.end_timestamp);
                // Determining status of appointment -> pending, processing, ready, done
                var now = new Date();

                if(endDateTime.getTime() <= now.getTime()) {
                    this.$store.state.meeting.status = 'done';
                    // Remove pending timer interval
                    clearInterval(this.pendingInterval);
                    // Remove processing interval
                    clearInterval(this.processingInterval);
                } else {
                    if (startDateTime.getTime() > now.getTime()) {
                        this.$store.state.meeting.status = 'pending';
                        this.setTimerText(startDateTime);
                    } else if (now.getTime() >= startDateTime.getTime() && now.getTime() < endDateTime.getTime()) {
                        this.$store.state.meeting.status = 'processing';
                        // Remove pending timer
                        clearInterval(this.pendingInterval);
                        // Scan api for appointmnet meeting
                        this.processingInterval = setInterval(() => {
                            this.fetchMeeting(appointment.id);
                            if(this.meeting && this.meeting.appointment != null) {
                                clearInterval(this.processingInterval);
                                this.$store.state.meeting.status = 'ready';
                                this.$refs.wsub.classList.add("appointment-widget__subtext--visible");
                                if(this.minutes >= this.meeting.duration) {
                                    this.$store.state.meeting.status = 'done';
                                    this.$refs.wsub.classList.remove("appointment-widget__subtext--visible");
                                } else if ((this.$store.state.meeting.meeting.user_joined_at === null && localStorage.getItem('role') === 'client') || (this.$store.state.meeting.meeting.specialist_joined_at === null && localStorage.getItem('role') === 'specialist')) {
                                    this.$refs.wsub.classList.add("appointment-widget__subtext--visible");
                                    let audio = document.getElementById('appointment-starting-audio');
                                    audio.play();
                                    this.$emit('openJoinMeeting');
                                }
                            }
                        }, 3000);
                    } else if(now.getTime() >= endDateTime.getTime()) {
                        this.$store.state.meeting.status = 'done';
                        // Remove pending timer interval
                        clearInterval(this.pendingInterval);
                        // Remove processing interval
                        clearInterval(this.processingInterval);
                    }
                }
            } else {
                this.$store.state.meeting.status = 'done';
                // Remove pending timer interval
                // clearInterval(this.pendingInterval);
                // Remove processing interval
                // clearInterval(this.processingInterval);
            }
        },
        join() {
        let meetingUrl =
            "/meetingroom?token=" +
            this.meeting.accessToken.token +
            "&joinVideo=true";
        this.$router.push(meetingUrl);
        },
    }
}
</script>

<style lang="scss">
    .appointment-widget{
        background-color: $color-primary;
        padding: 15px 0px;
        margin-top: 20px;
        text-align: center;
        font-weight: 500;
        border-radius: 25px;
        color: white;
        max-width: 245px;
        position: relative;
        
        &--pending{
            span:last-of-type{
                display: none;
            }

            &:hover{
                span:first-of-type{
                    display: none;
                }

                span:last-of-type{
                    display: block;
                    cursor: pointer;
                }
                i{
                    display: none;
                }
            }
        }

        &--processing{
            background-color: $color-warning;
        }

        &--ready{
            background-color: #00CD98;
        }

        &__specialist-img{
            position: absolute;
            left: 4px;
            top: 50%;
            transform: translate(0%, -50%);
            height: 40px;
            width: 40px;
            max-height: 40px;
            max-width: 40px;
            border-radius: 50%;
            background-color: white;
            border: 1px solid white;
            overflow: hidden;
            display: flex;

            img{
                object-fit: cover;
                width: 100%;
                height: 100%;
                margin: auto;
            }
        }

        &__subtext{
            display: none;
            margin-top: 5px;

            & > small{
                margin: auto;
                text-align: center;
                opacity: 0.8;
            }

            & span {
                color: $color-primary;
                font-weight: bold;
                cursor: pointer;
            }

            &--visible{
                display: flex;
            }
        }
    }
</style>